import { dialogAtom } from '@/state/dialog/atom'
import type { DialogType } from '@/state/dialog/dialogTypes'
import { useAtomValue, useSetAtom } from 'jotai'
import { dialogComponents } from './DialogComponents'

export const DialogManager = () => {
  const dialog = useAtomValue(dialogAtom)
  const setDialog = useSetAtom(dialogAtom)
  const { type, data } = dialog

  const handleOnClose = () => {
    setDialog({
      type: null,
      data: undefined,
    })
  }

  if (!type) return null
  const DialogComponent = dialogComponents[type as DialogType]
  if (!DialogComponent) return null

  // Type assertion needed: DialogPropsType ensures type safety, but spread loses inference
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <DialogComponent {...(data as any)} onClose={handleOnClose} />
}
